import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		minWidth: '360px',
		maxWidth: '400px',
		borderRadius: token('radius.large'),
		boxShadow: token('elevation.shadow.overflow'),
		overflow: 'hidden',
	},
});

/**
 * Applies the popup chrome (size constraints, border radius, shadow) shared by
 * {@link CardLoading}, {@link CardError}, and the populated card rendered via
 * {@link UserProfileCardRelay}. Keeps popup-specific styles out of the
 * presentational {@link UserProfileCard} component.
 */
export function CardPopupWrapper({ children }: { children: ReactNode }): React.JSX.Element {
	return (
		<Box xcss={styles.wrapper} backgroundColor="elevation.surface.overlay">
			{children}
		</Box>
	);
}
